import { defineComponent } from 'vue';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';
import IconDrawer from '../vuecontrols/IconDrawer.vue';
import { buildNavigationDrawerIconItems } from '../vuecontrols/navigationDrawerIconItems.js';

const defaultMenuModel = [
    {
        Icon: { Icon: 'mdi mdi-home-variant' },
        Title: 'Home',
        location: 'Top',
    },
    {
        Icon: { Icon: 'mdi mdi-view-list-outline' },
        Title: 'Administration',
        location: 'Top',
    },
    {
        Icon: { Icon: 'mdi mdi-account' },
        Title: 'User',
        location: 'Bottom',
    },
];

function cloneDefaultMenuModel() {
    return JSON.parse(JSON.stringify(defaultMenuModel));
}

function modelHasInterpolation(value) {
    if (typeof value === 'string')
        return value.includes('{') && value.includes('}');
    if (Array.isArray(value))
        return value.some(modelHasInterpolation);
    if (value && typeof value === 'object')
        return Object.values(value).some(modelHasInterpolation);
    return false;
}

export default defineComponent({
    name: 'navigation-drawer-dsgn',
    mixins: [BaseComponentMixin],
    components: {
        IconDrawer,
    },
    data() {
        return {
            collapsed: true,
            urlModel: null,
        };
    },
    async created() {
        if (this.controlData?.SourceType === 'Url' && this.controlData?.SourceUrl) {
            const sourceurl = utils.compile(this, this.controlData.SourceUrl);
            try {
                this.urlModel = await utils.api.get(utils.evaluate(sourceurl, this));
            }
            catch (e) {
                /* urlModel stays null */
            }
        }
    },
    computed: {
        effectiveModel() {
            const cd = this.controlData;
            if (!cd)
                return cloneDefaultMenuModel();

            if (cd.SourceType === 'Url') {
                const m = this.urlModel;
                if (!m || !Array.isArray(m))
                    return cloneDefaultMenuModel();
                return modelHasInterpolation(m) ? cloneDefaultMenuModel() : m;
            }

            if (cd.SourceType === 'Raw' && cd.SourceRaw != null) {
                const raw = cd.SourceRaw;
                if (typeof raw === 'string') {
                    try {
                        const parsed = JSON.parse(raw);
                        if (Array.isArray(parsed))
                            return modelHasInterpolation(parsed) ? cloneDefaultMenuModel() : parsed;
                    }
                    catch (e) {
                        /* not JSON */
                    }
                    if (raw.includes('{') && raw.includes('}'))
                        return cloneDefaultMenuModel();
                    return cloneDefaultMenuModel();
                }
                if (Array.isArray(raw))
                    return modelHasInterpolation(raw) ? cloneDefaultMenuModel() : raw;
                return cloneDefaultMenuModel();
            }

            return cloneDefaultMenuModel();
        },
        dense_icons() {
            return this.controlData?.IconSize === 'Dense';
        },
        backgroundColorResolved() {
            const bc = this.controlData?.BackgroundColor;
            if (!bc || typeof bc !== 'string')
                return null;
            if (bc.includes('{') && bc.includes('}'))
                return null;
            return bc;
        },
        iconDrawerItems() {
            return buildNavigationDrawerIconItems({
                model: this.effectiveModel,
                collapsed: this.collapsed,
                translate: (k) => k,
                generateUUID: () => utils.generateUUID(),
                onCollapseToggle: () => { this.collapsed = !this.collapsed; },
            });
        },
        previewTabId() {
            const t = this.iconDrawerItems.find((i) => i.type === 'tab');
            return t != null ? t.id : 0;
        },
    },
    props: {
    },
    render() {
        if (!this.controlData)
            return null;

        const drawerWidth = this.collapsed ? 56 : 230;
        const useDark = this.controlData.DarkTheme || false;
        const wrapperStyle = {
            ...utils.getSize(this.controlData.SizeOptions, this.parentType, this.$parent),
            zIndex: 2000,
            width: `${drawerWidth}px`,
            minWidth: `${drawerWidth}px`,
            maxWidth: `${drawerWidth}px`,
            flexShrink: 0,
            overflow: 'hidden',
            transition: 'width 0.25s ease, min-width 0.25s ease, max-width 0.25s ease',
        };

        return (
            <div
                class={{
                    'c-NavigationDrawer': true,
                    'c-NavigationDrawer--standalone': true,
                    [`c-name-${this.name || 'unnamed'}`]: true,
                    'designer-container': true,
                    selected: this.selected$,
                }}
                style={wrapperStyle}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ 'designer-container-hovering': true, 'designer-container-selected': this.selected$ }} />

                <IconDrawer
                    items={this.iconDrawerItems}
                    modelValue={this.previewTabId}
                    previewMode={true}
                    width={drawerWidth}
                    expanded={!this.collapsed}
                    dense={this.dense_icons}
                    dark={useDark}
                    backgroundColor={this.backgroundColorResolved}
                    root={this.root}
                    scopeitems={this.scopeitems}
                    controlscope={this.controlscope}
                    namePrefix={this.name}
                />
            </div>
        );
    },
});
